import { render, staticRenderFns } from "./VisualHero.vue?vue&type=template&id=6a7540e2"
import script from "./VisualHero.vue?vue&type=script&lang=js"
export * from "./VisualHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports